export default class ItemEventTypeService {
    static get CreateId() {
        return 1;
    }
    static get ChangeStatusId() {
        return 2;
    }
    static get GradeChangeId() {
        return 3;
    }
    static get CommentId() {
        return 4;
    }
    static get EditId() {
        return 5;
    }
    static get NoteAddedToAlertId() {
        return 6;
    }
    static get SentId() {
        return 12;
    }
}
